import React from 'react';

export const appReactMemo: <T>(component: T) => T = React.memo;
